import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setUsePartnerName,setPartner } from "../Reducer/localStorageSlice";

function usePartnerName() {
    const [formattedName, setFormattedName] = useState(null)
    const dispatch = useDispatch();
    const localData = useSelector((state) => state?.localStorage)
    const { usePartnerName } = localData

    let testUrl = new URL(window.location.href);

    useEffect(() => {

        // if we have partner name in ls we will use it 
        const partnerNameLocalStorage = usePartnerName || "";


        if (partnerNameLocalStorage && partnerNameLocalStorage !== null) {
            setFormattedName(() => partnerNameLocalStorage)
                dispatch(setPartner(partnerNameLocalStorage));
            
        }
        else {
            // if its a shared link we will use partner name from search params
            if (testUrl?.searchParams?.get("partnerName")) {
                setFormattedName(() => testUrl?.searchParams?.get("partnerName") ? testUrl?.searchParams?.get("partnerName") : 'partner-name')
            }
            else {

                // if its prod env  FOR SUBDOMAIN IMPLEMENTATION 
                if (testUrl?.host?.includes("expo365.app")) {
                    const firstSplit = testUrl?.href?.split('/')[2];
                    const secondSplit = firstSplit?.split('.')[0];
                    // const partner = secondSplit?.replace(/-/g, " ") || "";
                    setFormattedName(() => secondSplit)
                }

                // if its any other url then we treat it as dev env 
                // in old code ".azure.com" sre hardcoded new domain wont work
                // if (testUrl.host === 'localhost:3000' || testUrl.host === 'connectsu-dev.eastus.cloudapp.azure.com:81') {

                else {
                    // const partnerNotFormat = testUrl?.pathname?.split("/")[2] ? testUrl?.pathname?.split("/")[2] : 'partner-name';
                    //commented above line to go with 'partner-name' 

                    // const formattedName = partnerNotFormat?.replace(/_/g, " ");
                    const partner = 'partner-name'; //changes from partnerNotFormat to 'partner-name'
                    setFormattedName(() => partner)
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        // if the value of partner name changes store it in back into ls
        if (formattedName)
            dispatch(setUsePartnerName(formattedName))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formattedName])

    return { formattedName }
}
export default usePartnerName